export default function shareIsAvailable() {
  if (typeof window === 'undefined') return false;

  return Boolean(window.navigator && navigator.share);
}
